// src/pages/Admin/Adherents/AdherentGroupCategory.jsx
import React, { useEffect, useState } from "react";
import { getGroupName } from "../../../services/groupServices";
import getCategory from "../../../utils/getCategory";
import getWeightCategory from "../../../utils/getWeightCategory";
import { getAdherentById } from "../../../services/adherentServices";
import { getLicenceAssuranceUrl } from "../../../services/dossierServices";
import { FaUsersCog, FaExternalLinkAlt } from "react-icons/fa";
import Button from "./../../../components/Button/Button";

export default function AdherentGroupCategory({ adherentId, onOpenManageGroups }) {
  const [groupNames, setGroupNames] = useState(["Chargement…"]);
  const [weightCategory, setWeightCategory] = useState("");
  const [ageCategory, setAgeCategory] = useState("");
  const [adherent, setAdherent] = useState({});
  const [licenceUrl, setLicenceUrl] = useState("");

  useEffect(() => {
    async function fetchData() {
      if (!adherentId) return;

      const adherentData = await getAdherentById(adherentId);
      setAdherent(adherentData || {});

      const names = await getGroupName(adherentId);
      setGroupNames(Array.isArray(names) && names.length ? names : ["N/A"]);

      const catAge = getCategory(adherentData?.date_naissance);
      setAgeCategory(catAge || "—");

      const catWeight = getWeightCategory(
        adherentData?.genre,
        catAge,
        adherentData?.poids
      );
      setWeightCategory(catWeight || "—");

      const url = await getLicenceAssuranceUrl(adherentId);
      setLicenceUrl(url || "");
    }

    fetchData();
  }, [adherentId]);

  return (
    <section className="rounded-2xl overflow-hidden ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/90 dark:bg-slate-900/60 backdrop-blur">
      {/* En-tête (style différent du bandeau dégradé) */}
      <div className="px-5 pt-5 sm:px-6">
        <h3 className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100">
          Groupes & catégories
        </h3>
        <div className="mt-2 h-1 w-20 rounded-full bg-gradient-to-r from-violet-500 via-fuchsia-500 to-pink-500" />
      </div>

      {/* Bouton pour ouvrir la modale de gestion des groupes */}
        {typeof onOpenManageGroups === "function" && (
          <Button
            text="Gérer les groupes"
            icon={FaUsersCog}
            onClick={onOpenManageGroups}
            className="!rounded-xl !bg-white/90 !text-slate-900 !hover:bg-white !shadow"
          />
        )}

      {/* Contenu */}
      <div className="px-5 pb-5 sm:px-6 sm:pb-6 mt-4">
        <div className="grid grid-cols-1 gap-4">
          {/* Groupes (chips) */}
          <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 p-4 bg-slate-100 dark:bg-slate-900/40">
            <div className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
              Groupes
            </div>
            <div className="flex flex-wrap gap-2">
              {groupNames.map((g, i) => (
                <span
                  key={`${g}-${i}`}
                  className="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium bg-white text-slate-800 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:ring-slate-700"
                >
                  {g}
                </span>
              ))}
            </div>
          </div>

          {/* Catégories */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 p-4 bg-slate-100 dark:bg-slate-900/40">
              <div className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
                Catégorie d’âge
              </div>
              <span className="inline-flex items-center rounded-md px-2.5 py-1 text-xs font-semibold bg-violet-100 text-violet-800 ring-1 ring-violet-200 dark:bg-violet-900/40 dark:text-violet-200 dark:ring-violet-800/50">
                {ageCategory || "—"}
              </span>
            </div>

            {/* <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 p-4 bg-slate-100 dark:bg-slate-900/40">
              <div className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-2">
                Catégorie de poids
              </div>
              <span className="inline-flex items-center rounded-md px-2.5 py-1 text-xs font-semibold bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-200 dark:ring-emerald-800/50">
                {weightCategory || "—"}
              </span>
            </div> */}
          </div>

          {/* Licence / Assurance */}
          {licenceUrl && (
            <div className="rounded-xl ring-1 ring-slate-200 dark:ring-slate-800 p-4 bg-slate-100 dark:bg-slate-900/40 flex items-center justify-between">
              <div>
                <div className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">
                  Licence / Assurance
                </div>
                <div className="text-sm text-slate-800 dark:text-slate-100 mt-1">
                  {adherent?.nom?.toUpperCase()} {adherent?.prenom}
                </div>
              </div>
              <a
                href={licenceUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 ring-1 ring-indigo-300/40 shadow-sm"
              >
                Voir la licence
                <FaExternalLinkAlt className="text-xs" />
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
